export default __webpack_public_path__ + "static/media/35.af7e2594.png";